// This file has been partially auto generated. 
// Please don't make any changes to the lenses.
// Feel free to add or remove annotated properties from
// the generator data class. The corresponding lenses 
// will be removed or added on the next run of the 
// lens generator. See below for more details.
package org.solyton.solawi.bid.module.bid.data.bidder

import org.evoleq.optics.Lensify
import org.evoleq.optics.ReadWrite
import org.evoleq.optics.lens.Lens

/**
 * Generator class.
 * Feel free to add or remove annotated properties from
 * the class. Make sure that they are annotated with
 * - @ReadOnly
 * - @ReadWrite
 * If you want that a property-lens will be generated
 * on the next run of the lens generator.
 * If not, just omit the annotation or annotate it with @Ignore.
 */
@Lensify data class BidderMails(
    @ReadWrite val emails: List<String> = emptyList(),
)

/**
 * Autogenerated Lens.
 * Read and manipulate [BidderMails.emails]
 */
@ReadWrite val emails: Lens<BidderMails, List<String>> by lazy{ Lens(
    get = {whole -> whole.emails},
    set = {part -> {whole -> whole.copy(emails = part)}}
) }
/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [BidderMails.emails]
 */
@ReadWrite fun BidderMails.emails(set: List<String>.()->List<String> ): BidderMails = copy(emails = set(emails)) 
